import React, { useContext, useEffect, useState } from "react";
import { LuPlus } from "react-icons/lu";
import { RiDeleteBin6Line } from "react-icons/ri";

import { CiUser, CiEdit, CiTrash } from "react-icons/ci";
import { MdOutlineCancel } from "react-icons/md";
import { useToast } from "../ToastContext";
import Utils from "../../utils/utils";

const EditAssignment = ({ props }) => {
  const { item, index, onClose, setAssignments } = props;
  const token = Utils.getToken();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const showToast = useToast();
  const [anyOneCanSee, setAnyOneCanSee] = useState(item.all ? true : false);
  const [submissionType, setSubmissionType] = useState(
    item.submissionType ? true : false
  );
  const [dueDates, setDueDates] = useState(
    JSON.parse(JSON.stringify(item.dueDates))
  );
  const [batchData, setBatchData] = useState([]);
  const [instructors, setInstructors] = useState([]);
  const [courseData, setCoursesData] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("PGP");
  const [questions, setQuestions] = useState([{ question: "", maxMarks: "" }]);
  let { date, time } = Utils.getCurrentDateTimeIndianTimeZone();

  const [endDateTime, setEndDateTime] = useState({ date: "", time: "" });

  const [formData, setFormData] = useState({
    title: item.title,
    remarks: item.remarks,
    description: item.description,
    batch: item.batch,
    endTime: endDateTime.time,
    endDate: endDateTime.date,
    maxMarks: item.maxMarks,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleBatchSelectChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      batch: prevFormData.batch.includes(value)
        ? prevFormData.batch.filter((item) => item !== value)
        : [...prevFormData.batch, value],
    }));

    setDueDates((prev) => {
      const updated = { ...prev };
      if (updated[value]) delete updated[value];
      else updated[value] = `${date}T${time}`;
      return updated;
    });
  };

  const handleDueDates = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setDueDates((prev) => ({ ...prev, [name]: value }));
  };

  const handleCourseChange = (e) => {
    const { value } = e.target;
    setSelectedCourse(value);
    fetchBatches(value);
  };

  const handleCheckedAnyone = (e) => {
    const { checked } = e.target;
    setAnyOneCanSee(checked);
  };

  const handleSingleSubmission = (e) => {
    const { checked } = e.target;
    setSubmissionType(checked);
  };

  const handleResetForm = () => {
    setFormData({
      title: "",
      description: "",
      remarks: "",
      instructor: "",
      course: selectedCourse,
      batch: [],
      endDate: date,
      endTime: time,
    });
    setAnyOneCanSee(false);
    setQuestions([{ question: "", maxMarks: "" }]);
  };

  const handleAddQuestion = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setQuestions([...questions, { question: "", maxMarks: "" }]);
  };

  const handleDeleteQuestion = (index) => {
    const updatedQuestions = questions.filter((_, i) => i !== index);
    setQuestions(updatedQuestions);
  };

  const handleQuestionChange = (index, field, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index][field] = value;
    setQuestions(updatedQuestions);
  };

  // =======================    APIs
  const fetchCourses = async () => {
    try {
      const response = await fetch(`${SERVER_URL}/batch/course`, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
      });

      if (response.status === 200) {
        const res = await response.json();
        setCoursesData(res);
      } else {
        const res = await response.json();
        showToast(res.message, "warning", false, 3000);
      }
    } catch (error) {
      showToast(
        "Courses Retreieval failed :" + error.message,
        "error",
        true,
        5000
      );
    }
  };

  const fetchBatches = async (activeBatch) => {
    try {
      const response = await fetch(`${SERVER_URL}/batch/${activeBatch}`, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
      });
      if (response.status === 200) {
        const res = await response.json();
        setBatchData(res);
      } else {
        const res = await response.json();
        showToast(res.message, "warning", true, 3000);
      }
    } catch (error) {
      showToast(
        "Batch Retreieval failed :" + error.message,
        "error",
        true,
        5000
      );
    }
  };

  const fetchInstructors = async () => {
    try {
      const response = await fetch(`${SERVER_URL}/instructors/`, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const ret = await response.json();
        setInstructors(ret.instructors);
      } else {
        const ret = await response.json();
        showToast(ret.message, "error", true, 3000);
      }
    } catch (error) {
      console.error("Error While Creating:", error);
    }
  };

  const HandleAssignmentEdit = async (e) => {
    e.preventDefault();

    const confirm = window.confirm("Are you sure ? ");
    if (!confirm) return;
    if (!formData.batch.length && !anyOneCanSee) {
      showToast(
        "Please select at least one Batch or Choose 'All'",
        "warning",
        true,
        3000
      );
      return;
    }

    if (formData.batch.length && anyOneCanSee) {
      showToast(
        "Please select either Batch or Choose 'All'",
        "warning",
        true,
        3000
      );
      return;
    }

    // const questionsNew = questions.filter((q, index) => {
    //   if (!q.question || !q.question.trim()) {
    //     showToast(
    //       "Please write something or delete the Question No. " + (index + 1),
    //       "warning",
    //       true,
    //       3000
    //     );
    //     return;
    //   } else {
    //     return {
    //       question: q.question.trim(),
    //       maxMarks: q.maxMarks && !isNaN(q.maxMarks) ? q.maxMarks : 0,
    //     };
    //   }
    // });
    // formData["questions"] = questionsNew;

    const newDueDates = formData.batch.reduce((acc, b) => {
      const isDate = dueDates[b];
      if (!isDate) {
        showToast(
          "Please check the batch selected and the corresponsind due date are matching.!",
          "warning",
          true,
          5000
        );
        return;
      } else {
        const [d, t] = isDate.split("T");
        const retDate = Utils.getCreationTime(d, t);
        acc[b] = retDate;
        return acc;
      }
    }, {});

    // const newDueDates = Object.fromEntries(
    //   Object.entries(dueDates).map(([batch, date]) => {
    //     const [d, t] = date.split("T");

    //     const retDate = Utils.getCreationTime(d, t);
    //     return [batch, retDate];
    //   })
    // );

    const obj = {};

    obj["all"] = anyOneCanSee ? 1 : 0;
    obj["submissionType"] = submissionType ? 1 : 0;
    obj["dueDates"] = newDueDates;
    if (obj["all"]) {
      obj["batch"] = [];
    } else obj["batch"] = formData["batch"];

    const updatedFields = ["title", "remarks", "description", "maxMarks"];

    updatedFields.forEach((key) => {
      if (formData[key] !== item[key]) {
        obj[key] = formData[key];
      }
    });

    try {
      const response = await fetch(
        `${SERVER_URL}/assignments/edit/${item._id}`,
        {
          method: "PUT",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({ formData: obj }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        const ii = result.assignment;
        setAssignments((prev) => prev.map((i) => (i._id === ii._id ? ii : i)));
        showToast(result.message, "success", false, 3000);
        handleResetForm();
      } else if (!response.ok) {
        const res = await response.json();
        showToast(res.error, "error", true, 5000);
      }
    } catch (error) {
      alert(`Something went wrong !!`);
    }
  };

  useEffect(() => {
    fetchCourses();
    fetchBatches("PGP");
  }, []);

  useEffect(() => {
    if (item?.dueDate) {
      const { date, time } = Utils.getDateTimeUTCToLocal(item.dueDate);
      setEndDateTime({ date, time });
      setFormData((prev) => ({ ...prev, endTime: time, endDate: date }));
    }

    if (item?.dueDates) {
      const dateObj = Object.fromEntries(
        Object.entries(item.dueDates).map(([d, t]) => {
          const { date, time } = Utils.getDateTimeUTCToLocal(t);
          return [d, `${date}T${time}`];
        })
      );
      setDueDates((prev) => ({ ...dateObj }));
    }
  }, [item?.dueDate || item.dueDates]);

  useEffect(() => {
    fetchInstructors();
    if (instructors.length > 0 && !formData.instructor) {
      setFormData((prev) => ({
        ...prev,
        instructor: `${instructors[0]._id}+${instructors[0].name}`,
      }));
    }
  }, [instructors]);

  return (
    <div bkl="EditAssignmentForm">
      <div
        className="menu min-h-full h-full overflow-x-hidden overflow-y-auto  p-4 rounded-l-lg"
        style={{
          WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE and Edge
        }}
      >
        <div>
          <p className="text-lg bold">Edit Assignment</p>
          <form onSubmit={HandleAssignmentEdit} className=" bg-white">
            <div className="flex items-center gap-2 mt-2 w-full">
              <label className="form-control w-full">
                <span className="label ">Assignment Title :</span>
                <input
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  required
                  placeholder="Please enter title assignment title.."
                  className="input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                />
              </label>
            </div>
            <div className="flex items-center gap-2 mt-2 w-full">
              <label className="form-control w-full">
                <span className="label ">Description :</span>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Please enter the description of the assignment.."
                  className="w-full px-4 py-2 min-h-12 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                />
              </label>
            </div>

            <div className="flex items-center gap-2 mt-2 w-full">
              <label className="form-control w-full">
                <span className="label ">Remarks :</span>
                <input
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleInputChange}
                  placeholder="Enter the remarks optional.."
                  className="input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                />
              </label>
            </div>
            {/* <div className="flex items-center gap-4 mt-2 w-full">
                                <label className="form-control w-[50%]">
                                    <span className="label ">Instructor :</span>
                                    <select
                                        name="instructor"
                                        value={formData.instructor || ""}
                                        onChange={handleInputChange}
                                        className="select select-sm outline-gray-300 outline-1
                      focus:border-pink-500 outline focus:outline-none"
                                    >
                                        <option
                                            value={""}
                                            key={"Select Instructor"}
                                            disabled
                                            style={{ fontWeight: "bold", color: "black" }}
                                        >
                                            Select Instructor
                                        </option>

                                        {instructors.map((instructor, i) => (
                                            <option
                                                value={instructor._id + "+" + instructor.name}
                                                key={instructor + i}
                                            >
                                                {instructor.name}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                            </div> */}

            <div className="flex items-center gap-4 mt-2 w-full">
              <label className="form-control w-[50%]">
                <span className="label ">Course :</span>
                <select
                  name="course"
                  value={selectedCourse}
                  onChange={handleCourseChange}
                  className="select select-sm outline-gray-300 outline-1
                      focus:border-pink-500 outline focus:outline-none"
                >
                  <optgroup label="Select Course">
                    {courseData.map((course, i) => (
                      <option value={course.name} key={course + i}>
                        {course.name}
                      </option>
                    ))}
                  </optgroup>
                </select>
              </label>

              {/* <label className="form-control w-fit">
                <span className="label ">All :</span>
                <input
                  type="checkbox"
                  name="anyone"
                  defaultChecked={anyOneCanSee}
                  onClick={handleCheckedAnyone}
                  className="checkbox border-pink-700  [--chkbg:theme(colors.pink.700)] [--chkfg:white]"
                />
              </label> */}
            </div>

            <div className="mt-2">
              <span className="label ">Select Multiple Batches :</span>
              <div className="flex flex-wrap gap-5">
                {batchData.map((batch) => (
                  <div key={batch.batch} className="flex items-center gap-2">
                    <label className="flex items-center p-1 bg-gray-100 rounded-md gap-1">
                      <input
                        type="checkbox"
                        value={batch.batch}
                        className="checkbox w-5 h-5 border-pink-700  [--chkbg:theme(colors.pink.700)] [--chkfg:white]"
                        checked={formData.batch.includes(batch.batch)}
                        onChange={() => handleBatchSelectChange(batch.batch)}
                      />
                      {batch.batch}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex items-center gap-4 mt-2 w-full">
              <div className="flex gap-4 w-1/2">
                <label className="form-control w-1/2">
                  <span className="label ">Single Submission :</span>
                  <input
                    type="checkbox"
                    name="submissionType"
                    defaultChecked={submissionType}
                    onClick={handleSingleSubmission}
                    className=" checkbox border-pink-700  [--chkbg:theme(colors.pink.700)] [--chkfg:white]"
                  />
                </label>

                {submissionType && (
                  <label className="form-control w-1/2 transition-all duration-200">
                    <span className="label ">Maximum Marks :</span>
                    <input
                      type="tel"
                      placeholder="Max Marks"
                      value={formData.maxMarks}
                      pattern="[0-9]*"
                      inputMode="numeric"
                      name="maxMarks"
                      onChange={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          handleInputChange(e);
                        } else {
                          alert("Please enter numbers only.");
                          return false;
                        }
                      }}
                      className="input-sm max-w-[120px] px-2 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                    />
                  </label>
                )}
              </div>
              {/* 
              {submissionType && (
                <div className="flex items-center gap-4  w-1/2  transition-all duration-200">
                  <label className="form-control w-[50%]">
                    <span className="label ">End Date :</span>
                    <input
                      type="date"
                      name="endDate"
                      value={formData.endDate}
                      onChange={handleInputChange}
                      required
                      className="input-sm  px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                    />
                  </label>

                  <label className="form-control w-[50%] ">
                    <span className="label ">End Time :</span>
                    <input
                      type="time"
                      name="endTime"
                      value={formData.endTime}
                      onChange={handleInputChange}
                      required
                      className="input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                    />
                  </label>
                </div>
              )} */}
            </div>

            <div className="divider divide-gray-800 font-semibold">
              Due Dates
            </div>

            <div className=" w-full" key={"Duedates-Label"}>
              <label className="form-control  ">
                {/* <div className="label flex justify-start gap-2"> */}
                {/* <span className="label-text font-semibold">Due Dates </span> */}
                <span className="label-text-alt text-red-500 ">
                  {" "}
                  Here select the due date for each batch *
                </span>
                {/* </div> */}
              </label>
            </div>

            <div className="mt-4 w-full">
              {Object.entries(dueDates).map(([batch, date]) => (
                <div
                  key={batch}
                  className="flex w-1/2 mb-2 items-center justify-between p-3 bg-gray-50 rounded-lg shadow-sm border border-gray-100"
                >
                  <label className="text-sm font-medium text-gray-800 flex-shrink-0 bg-white px-2 py-1 rounded-md  shadow-lg ">
                    {batch}
                  </label>

                  <input
                    name={batch}
                    type="datetime-local"
                    value={date}
                    onChange={handleDueDates}
                    className="input-sm px-4 py-3 rounded-lg bg-white border focus:shadow-inner focus:bg-white focus:outline-none"
                  />
                </div>
              ))}
            </div>

            {/* <div
              className="flex items-center gap-4 mt-2 w-full"
              key={"Questions-Label"}
            >
              <label className="form-control w-[70%]">
                <span className="label font-semibold">Questions</span>
              </label>

              <label className="form-control w-[25%]">
                <span className="label font-semibold">Max Marks (NA)</span>
              </label>
              <label className="form-control  w-[5%]"></label>
            </div>
            {questions.map((q, index) => (
              <div
                className="flex items-center gap-4 mt-2 w-full"
                key={"questions" + index}
              >
                <label className="form-control w-[70%] ">
                  <textarea
                    type="text"
                    placeholder={`Question ${index + 1}`}
                    value={q.question}
                    onChange={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleQuestionChange(index, "question", e.target.value);
                    }}
                    required
                    className="w-full min-h-12 px-4 py-2 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>

                <label className="form-control w-[15%]  ">
                  <input
                    type="telephone"
                    placeholder="Max Marks"
                    value={q.maxMarks}
                    onChange={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleQuestionChange(index, "maxMarks", e.target.value);
                    }}
                    pattern="[0-9]*"
                    className="input-sm px-2 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>

                <label className="form-control w-[10%] flex justify-center items-center ">
                  {index == questions.length - 1 ? (
                    <div className=" w-full flex justify-between">
                      <button
                        onClick={handleAddQuestion}
                        className="flex items-center justify-center w-6 h-6 rounded-full border border-pink-700 bg-white shadow-md hover:bg-pink-50 active:bg-pink-100 focus:outline-none"
                      >
                        <LuPlus className="w-5 h-5 text-pink-700" />
                      </button>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleDeleteQuestion(index);
                        }}
                        className="flex items-center justify-center w-6 h-6 rounded-full border border-red-700 bg-white shadow-md hover:bg-red-50 active:bg-pink-100 focus:outline-none "
                      >
                        <RiDeleteBin6Line className="w-4 h-4 text-red-500" />
                      </button>
                    </div>
                  ) : (
                    <div className=" w-full flex justify-end">
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleDeleteQuestion(index);
                        }}
                        className="flex items-center justify-center w-6 h-6 rounded-full border border-red-700 bg-white shadow-md hover:bg-red-50 active:bg-pink-100 focus:outline-none "
                      >
                        <RiDeleteBin6Line className="w-4 h-4 text-red-500" />
                      </button>
                    </div>
                  )}
                </label>
              </div>
            ))} */}

            <div className="gap-2 bg-white mt-4 z-10 flex justify-between sticky bottom-1">
              <div className="flex gap-2">
                <button
                  className="px-3 py-1 flex justify-center items-center gap-1 btn-xs  tracking-[.1em] uppercase border border-green-600 rounded-lg text-green-600 hover:text-green-800 hover:border-green-800 hover:shadow-lg "
                  type="submit"
                >
                  SAVE ASSIGNMENT
                </button>
              </div>
              <button
                className="px-3 py-1 flex justify-center items-center gap-1 btn-xs  tracking-[.1em] uppercase border border-red-600 rounded-lg text-red-600 hover:text-red-800 hover:border-red-800 hover:shadow-lg "
                onClick={() => onClose()}
              >
                CANCEL
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditAssignment;
